import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IDailyWorkLogTotal} from "../../../../../../utils/interfaces/my_projects/IDailyWorkLogTotal";


const useApiGetDailyTotalsWorkLogs = (): UseQueryResult<IDailyWorkLogTotal[], CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined): Promise<IDailyWorkLogTotal[]> {
        try {
            const response = await get(`/api/company/${company_token}/my_projects/work_logs/grouped_by_day/`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetDailyWorkLogsTotals"],
        queryFn: () => doGet(selectedCompany?.company_token,),
    })
};

export default useApiGetDailyTotalsWorkLogs